<template>
  <div id="setting-other-default-layout">
    <div id="setting-other-component" :class="componentClassName">
      <a-page-heading :id="idName[3]">ヘルプ</a-page-heading>
      <m-section>
        <m-action-card :id="idName2[5]" title="ユーザーマニュアル" :header-border="true" :narrow-body="true">
          <m-form-input label="COTOHA Call Center" content-layout="vertical">
            <a id="link2" :href="COTOHACallCenterManualURL" target="blank">【Webブラウザ版】</a>
            <a id="link2Mobile" :href="COTOHACallCenterManualURLMobile" target="blank">【モバイルアプリ版】</a>
          </m-form-input>
          <m-form-input v-if="!trialCompany" label="COTOHA Voice DX Basic（AIオペレーター機能）">
            <a id="link3" :href="COTOHAVoiceDXBasicManualURL" target="blank"
              >【COTOHA Voice DX Basic】ユーザーマニュアル</a
            >
          </m-form-input>
        </m-action-card>
      </m-section>
      <m-section>
        <m-action-card :id="idName2[6]" title="お問い合わせ" :header-border="true" :narrow-body="true">
          <template v-if="!trialCompany">
            <a-text
              >問い合わせフォーム　<a id="link4" :href="CCAASSupportURL" target="blank">{{
                CCAASSupportURL
              }}</a></a-text
            >
            <a-text>お問い合わせ　⇒　【設定方法、ご利用方法について】　または　【故障について】</a-text><br />
          </template>
          <template v-if="trialCompany">
            <a-text
              >WEBでのお問い合わせは<a id="link4" :href="CCAASTrialInquiryFormURL" target="blank">こちら</a></a-text
            >
            <a-text>電話　0120-518506</a-text><br />
            <a-text>受付時間：9:00~17:00 土日祝を除く平日</a-text>
            <a-text>※フォームの入力は24時間可能ですが、回答までにお時間を頂く場合があります。</a-text><br />
          </template>
        </m-action-card>
      </m-section>
    </div>

    <!-- Confirm, Error Modal -->
    <teleport to="body">
      <o-modal
        id="help_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="close-modal-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import OModal from '@/components/organisms/modal';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

import { customValidate } from '@/common/customValidate.js'; // #2537
import { utils } from '@/common/utils.js';
import { cloneDeep } from 'lodash';

export default {
  name: 't-help',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    OModal,
  },
  mixins: [customRequest, customValidate], // #2537
  props: {
    class: {
      type: String,
      default: '',
    },
    // # 2537
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      COTOHACallCenterManualURL: '',
      COTOHACallCenterManualURLMobile: '',
      COTOHAVoiceDXBasicManualURL: '',
      CCAASSupportURL: '',
      CCAASTrialInquiryFormURL: '',
      authInfo: this.$store.state.user.authInfo,
      idName: [],
      idName2: [],
      trialCompany: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-help');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async created() {
    for (let i = 1; i <= 3; i++) {
      this.idName[i] = 'h1-settingother' + i;
    }
    for (let i = 1; i <= 6; i++) {
      this.idName2[i] = 'h4-settingother' + i;
    }

    // For Trial
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.trialCompany = true;
    }
    await this.handlerFetchSettingOther();
  },
  methods: {
    handlerFetchSettingOther: async function () {
      const self = this;
      await this.postRequest('/settingother')
        .then(data => {
          if (data.status === 'success') {
            if (data.data) {
              self.COTOHACallCenterManualURL = data.data.COTOHACallCenterManualURL
                ? data.data.COTOHACallCenterManualURL
                : '';
              self.COTOHACallCenterManualURLMobile = data.data.COTOHACallCenterManualURLMobile
                ? data.data.COTOHACallCenterManualURLMobile
                : '';
              self.COTOHAVoiceDXBasicManualURL = data.data.COTOHAVoiceDXBasicManualURL
                ? data.data.COTOHAVoiceDXBasicManualURL
                : '';
              self.CCAASSupportURL = data.data.CCAASSupportURL ? data.data.CCAASSupportURL : '';
              self.CCAASTrialInquiryFormURL = data.data.CCAASTrialInquiryFormURL
                ? data.data.CCAASTrialInquiryFormURL
                : '';
            }
          } else {
            self.showErrorModal(messageContent.requireTry('設定の取得'));
          }
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('設定の取得'));
        });
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
